import styled from 'styled-components';
interface BoxContainerProps {
  width?: string;
  height?: string;
  padding?: string;
  borderRadius?: string;
  backgroundColor?: string;
  isDisplay?: boolean;
}

const BoxContainer = styled.div<BoxContainerProps>`
  width: ${(props) => props.width ?? '960px'};
  height: ${(props) => props.height ?? 'auto'};
  padding: ${(props) => props.padding ?? '30px'};
  border-radius: ${(props) => props.borderRadius ?? '12px'};
  background-color: ${(props) =>
    props.backgroundColor ?? props.theme.colors.white};
  display: ${(props) => (props.isDisplay === false ? 'none' : 'block')};
  overflow: hidden;
`;

export const OneLineBoxContainer = styled.div`
  height: 48px;
  width: 420px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.grayBgLight};
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface SearchControlBoxContainerProps {
  width?: string;
}

export const SearchControlBoxContainer = styled.div<SearchControlBoxContainerProps>`
  width: ${(props) => props.width ?? `960px`};
  padding: 24px 0px;
  border-radius: 12px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default BoxContainer;
